import React from 'react'
import { IconSeekers, ImgS } from 'ui-seeker/core'
import { formatPercentage } from 'ui-seeker/utils'
import CountUp from "react-countup"
import { useTranslation } from 'react-i18next'
import { IMAGE } from '../../../@common/constants'
import { formatIntegerPrice, integerPriceCountUpProps } from 'app/@utils/price'

// Only used by the Competition analyzer: prices without decimals (CU-869fmuqwb).
export default function AppOccupationCard({ data,  currency = null }) {
    const { t } = useTranslation('common')
    const { label, diff, value, value_min, value_max, diff_min, diff_max, location_category, occupancy, type_accommodation, site_name } = data
    const currencyConfig = integerPriceCountUpProps(currency)
    const diffClass = !!diff ? (diff < 0 ? 'diff-success' : 'diff-error') : ''

    const formatValue = () => {
        return !!value ? <CountUp end={value} {...currencyConfig} /> : formatIntegerPrice(value)
    }

    const renderMinMax = () => {
        if (!value_min && !value_max) return null
        const diffMinClass = !!diff_min ? (diff_min < 0 ? 'diff-success' : 'diff-error') : ''
        const diffMaxClass = !!diff_max ? (diff_max < 0 ? 'diff-success' : 'diff-error') : ''
        return <div style={{ display: 'flex', gap: '12px', marginLeft: '16px', paddingLeft: '16px', borderLeft: '1px solid rgba(0,0,0,0.1)' }}>
            {!!value_min && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '1px' }}>
                <span style={{ fontSize: '9px', color: '#9CA3AF', fontWeight: 600, letterSpacing: '0.4px' }}>{t('metrics.min')}</span>
                <span style={{ fontSize: '13px', fontWeight: 700, color: '#10B981' }}>
                    <CountUp end={value_min} {...currencyConfig} />
                </span>
                {!!diff_min && <span className={`app-card__price-panel-diff ${diffMinClass}`} style={{ fontSize: '10px' }}>
                    {formatPercentage(diff_min, { decimals: 1 })}
                    <IconSeekers icon={diff_min < 0 ? 'arrow-down' : 'arrow-up'} iconType="fontAwesome" iconWeight='fa' style={{ marginLeft: '2px' }} />
                </span>}
            </div>}
            {!!value_max && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '1px' }}>
                <span style={{ fontSize: '9px', color: '#9CA3AF', fontWeight: 600, letterSpacing: '0.4px' }}>{t('metrics.max')}</span>
                <span style={{ fontSize: '13px', fontWeight: 700, color: '#EF4444' }}>
                    <CountUp end={value_max} {...currencyConfig} />
                </span>
                {!!diff_max && <span className={`app-card__price-panel-diff ${diffMaxClass}`} style={{ fontSize: '10px' }}>
                    {formatPercentage(diff_max, { decimals: 1 })}
                    <IconSeekers icon={diff_max < 0 ? 'arrow-down' : 'arrow-up'} iconType="fontAwesome" iconWeight='fa' style={{ marginLeft: '2px' }} />
                </span>}
            </div>}
        </div>
    }

    const renderStars = () => {
        if (!location_category) return null;
        return Array.from({ length: location_category }, (_, index) => (
            <IconSeekers
                key={index}
                style={{ color: '#FFC107', fontSize: '10px' }}
                icon="star"
                iconType="fontAwesome"
                iconWeight="fa"
            />
        ));
    };

    const iconSite = {
        src: `${IMAGE.ASSETS}/${site_name?.split('.')[0]}-mini.png`,
        alt: `${site_name} logo`,
        onError: i => i.target.src = `${IMAGE.ASSETS}/web.png`,
        style: { width: '12px', margin: '-2px 2px 0 0' }
    }

    return <div className={`app-card ${diff > 0 ? 'app-card--error' : ''}`} style={{ height: '95px' }}>
        <div className="app-card__text-panel">
            {/* Header en una sola línea: label + estrellas + site + accommodation + occupancy.
                `flex-wrap: wrap` deja que los chips bajen a una segunda línea en pantallas
                estrechas, manteniendo la card compacta cuando hay ancho de sobra. */}
            <div className="app-card__text-panel-header" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', rowGap: '4px' }}>
                <p className="app-card__text-panel-label" style={{ margin: 0 }}>{label || t('metrics.locationOverview')}</p>
                <div className="flex items-center">
                    {renderStars()}
                </div>
                {!!site_name && <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#6B7280' }}>
                    <div className="tag">
                        <ImgS {...iconSite} /> {site_name}
                    </div>
                </span>}
                {!!type_accommodation && <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#6B7280' }}>
                    <IconSeekers icon="bed" iconType="fontAwesome" iconWeight="fa" style={{ fontSize: '10px', color: '#3B82F6' }} />
                    <span style={{ fontWeight: '600' }}>{type_accommodation}</span>
                </span>}
                {!!occupancy && <span style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#6B7280' }}>
                    <IconSeekers icon="users" iconType="fontAwesome" iconWeight="fa" style={{ fontSize: '10px', color: '#10B981' }} />
                    <span style={{ fontWeight: '600' }}>{occupancy}</span>
                </span>}
            </div>
        </div>
        <div className="app-card__price-panel">
            <span className="app-card__price-panel-value">
                <p className="app-card__text-panel-subtitle">{t('metrics.averagePrice')}</p>
                {formatValue()}
                {!!diff && <span className={`app-card__price-panel-diff ${diffClass}`}>
                    <span className="app-card__price-panel-diff-value">
                        {formatPercentage(diff, { decimals: 2 })}
                    </span>
                    <IconSeekers
                        className="app-card__price-panel-diff-icon"
                        icon={diff < 0 ? 'arrow-down' : 'arrow-up'}
                        iconType="fontAwesome"
                        iconWeight='fa'
                    />
                </span>}
            </span>
            {renderMinMax()}
        </div>
    </div>
}
